/*
 * @Author: Tina Huang
 * @Date: 2024-01-24 12:07:08
 * @LastEditors: Tina Huang
 * @LastEditTime: 2025-02-08 15:28:00
 * @Description:
 */
import { Carousel, Image } from 'antd'
import ToUse from '../components/ToUseButton'

type BlocksType = {
  title: string
  subtitle: string
  img: string
}

export default function Panel() {
  const isMobile = window.innerWidth <= 750
  const blocks: BlocksType[] = [
    {
      title: '个性化自定义你的组件',
      subtitle: '无个数限制，支持嵌入Notion，Wolai，FlowUs等笔记软件',
      img: 'home.png',
    },
    {
      title: '打造个性化个人页面',
      subtitle: '丰富页面，把笔记做成网站',
      img: 'home-page_1.png',
    },
    {
      title: '更加直观的数据感受',
      subtitle: '也可作为模块分割的工具',
      img: 'home-page_2.png',
    },
  ]

  const styleProps = {
    title: isMobile ? 'text-2xl font-bold' : 'text-5xl font-bold',
    subtitle: isMobile ? 'text-lg mt-2' : 'mt-3 text-xl',
    image: isMobile ? { width: '100%', margin: '0 auto' } : { width: 720, height: 450, margin: '0 auto' },
    box: isMobile ? 'flex flex-col justify-center items-center mt-12' : 'flex justify-around items-center mt-12',
    titleBox: isMobile ? 'w-full pb-2 text-center' : 'w-1/2 pl-8',
  }
  // const contentStyle: React.CSSProperties = {
  //   height: '160px',
  //   color: '#fff',
  //   lineHeight: '160px',
  //   textAlign: 'center',
  //   background: '#364d79',
  // }

  return (
    <>
      <Carousel autoplay>
        {blocks.map((item) => (
          <div>
            <div className={styleProps.box} key={item.title}>
              <div className={styleProps.titleBox}>
                <h1 className={styleProps.title}>{item.title}</h1>
                <p className={styleProps.subtitle}>{item.subtitle}</p>
              </div>
              <Image src={item.img} style={styleProps.image} alt="" preview={false} />
            </div>
          </div>
        ))}
      </Carousel>
      {isMobile ? (
        <div className="text-center mt-4">
          <h1 className="text-2xl mb-2">开始配置你的组件吧</h1>
          <p className="text-xl mb-2">Get started for free.</p>
          <ToUse home={true} />
        </div>
      ) : (
        <div className="text-center mt-12">
          <h1 className="text-3xl mb-5">开始配置你的组件吧</h1>
          <p className="text-xl mb-5">Get started for free.</p>
          <ToUse home={true} />
        </div>
      )}
    </>
  )
}
